import React, { useState } from 'react';
import qs from 'qs';
import { useNavigate } from 'react-router';
import type { Account, User } from '@axiom/validation';
import type { ButtonProps } from '@axiom/ui';
import { Button } from '@axiom/ui';
import { isAhqUser } from '@axiom/utils';

import { ImpersonationAccountPickerModal } from '../ImpersonationAccountPickerModal/ImpersonationAccountPickerModal';
import { ImpersonationClientPickerModal } from '../ImpersonationClientPickerModal/ImpersonationClientPickerModal';

type PickContact = Pick<Account['contacts'][number], 'email' | 'id'>;

export interface StartEngagementButtonProps {
  account?: Account;
  children: React.ReactNode;
  name: string;
  onLoggedOutSubmissionClick?: () => void;
  pattern: ButtonProps['pattern'];
  user?: User | null;
  variation: ButtonProps['variation'];
}

export const StartEngagementButton = ({
  account,
  children,
  name,
  onLoggedOutSubmissionClick,
  pattern,
  user,
  variation,
}: StartEngagementButtonProps) => {
  const navigate = useNavigate();
  const [collectData, setCollectData] = useState(false);
  const [impersonationAccount, setImpersonationAccount] = useState<
    Account | undefined
  >();
  const [impersonationContact, setImpersonationContact] = useState<
    Account['contacts'][number] | undefined
  >();

  const buildUrl = (url: string, contact: PickContact) => {
    return isAhqUser(user)
      ? `${url}${qs.stringify({ contactId: contact.id, contactEmail: contact.email }, { addQueryPrefix: true })}`
      : url;
  };

  const clearData = () => {
    setCollectData(false);
    setImpersonationContact(undefined);
    setImpersonationAccount(undefined);
    return true;
  };

  const referenceAccount = account || impersonationAccount;
  const referenceContact = user?.contact || impersonationContact;

  const handleNavigateToDirectEngagement = (
    refAccount: Account,
    refContact: Pick<Account['contacts'][number], 'email' | 'id'>
  ) => {
    void navigate(buildUrl(`/account/${refAccount.id}/intake`, refContact));
    return clearData();
  };

  return (
    // this <div/> prevents BUG FR-5898
    <div>
      <Button
        name={name}
        onClick={() => {
          if (!user) {
            onLoggedOutSubmissionClick?.();
          } else if (!referenceAccount || !referenceContact) {
            setCollectData(true);
          } else {
            handleNavigateToDirectEngagement(referenceAccount, {
              email: referenceContact.email,
              id: referenceContact.id,
            });
          }
        }}
        variation={variation}
        pattern={pattern}
      >
        {children}
      </Button>
      {collectData ? (
        <div>
          {referenceAccount ? (
            <ImpersonationClientPickerModal
              account={referenceAccount}
              onClose={() => {
                clearData();
              }}
              selectContact={contact => {
                setImpersonationContact(contact);
                handleNavigateToDirectEngagement(referenceAccount, {
                  email: contact.user.email,
                  id: contact.id,
                });
              }}
              submitButtonCopy="Start new Engagement"
            />
          ) : (
            <ImpersonationAccountPickerModal
              onClose={() => {
                clearData();
              }}
              selectAccount={chosenAccount => {
                setImpersonationAccount(chosenAccount);
              }}
            />
          )}
        </div>
      ) : null}
    </div>
  );
};
